import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'
import { Author } from '../interfaces'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'

export interface PinnedReplyInContentProps {
  author: Author
  content: string
  repliedAt: string
}

const PinnedReplyInContent = ({ author, content, repliedAt }: PinnedReplyInContentProps) => {
  const formattedRepliedAt = formatDateInLocalTimezone(new Date(repliedAt).getTime() / 1000)
  return (
    <div className='post--answer--container'>
      <strong>Pinned reply by {author.username} - {formattedRepliedAt}</strong>
      <Content content={content} isControl />
    </div>
  )
}

export default PinnedReplyInContent
